import { router } from '@inertiajs/react'
import { Badge } from '@/components/ui/Badge'
import { Button } from '@/components/ui/Button'
import type { Person } from '@/lib/person'

// Props from Plan::CycleTaskProps#pricing_revision_submit_props and
// #monthly_revision_submit_props, read by the Products & Pricings and By Month
// submit pages for their reviewer pickers.
export interface ChannelRevisionSubmitData {
  plan_id: string
  channel_id: string
  default_reviewer_ids: string[]
  people: Person[]
}

// Header widget on a channel editor while editing something already published
// with no task open (pricings, monthly plan), same as the Top Down
// RevisionSubmitWidget: the changes live in the channel's draft until
// submitted on the submit page, where the reviewers are picked and the
// changes are shown against the published figures. Submitting there creates
// the revision task; afterwards ChannelTaskWidget takes over.
export default function ChannelRevisionSubmitWidget({ subject, channelName, draftOpen, missing, submitHref }: {
  subject: string
  channelName: string
  draftOpen: boolean
  missing: string[]
  submitHref: string
}) {
  const ready = draftOpen && missing.length === 0
  const status = !draftOpen ? 'No changes yet' : missing.length === 0 ? 'Ready to submit' : `Missing: ${missing.join(', ')}`

  return (
    <div
      className="flex min-w-0 flex-col gap-0.5 rounded-lg border px-3 py-1.5"
      style={{ background: 'var(--background)', borderColor: 'var(--border)' }}
    >
      <div className="flex items-center gap-2">
        <Badge variant="info" className="px-1.5 py-0 text-[10px] whitespace-nowrap">Revision</Badge>
        <span className="whitespace-nowrap text-xs font-medium text-foreground">Editing published {subject} for {channelName}</span>
      </div>
      <div className="flex items-center gap-2 text-[11px] text-muted-foreground">
        <span className="whitespace-nowrap">{status}</span>
        <Button
          size="sm"
          className="ml-auto h-5 px-2 text-[11px]"
          disabled={!ready}
          onClick={() => router.visit(submitHref)}
        >
          Submit for review
        </Button>
      </div>
    </div>
  )
}
